export default __webpack_public_path__ + "static/media/Group9231.9cc0e7db.svg";